import * as angular from 'angular';
import { ComponentDefinition } from '../../../models';

class ConfirmApplyAllForGroupModalController implements angular.IComponentController {
    isLoading: boolean;
    
    static $inject = [];
}

export const wtConfirmApplyAllForGroupModal: ComponentDefinition = {
    componentId: 'wtConfirmApplyAllForGroupModal',
    controller: ConfirmApplyAllForGroupModalController,
    controllerAs: 'vm',
    template: require('./confirmApplyAllForGroupModal.component.html'),
    bindings: {
        apply: '&'
    }
};